import { CreditProduct, DebtConsolidationProduct, MeResponse } from '../../api';
import { ProductName } from '../../constants';

export const selectUsername = (me: MeResponse) => me.givenName ?? me.firstName;

export const selectFullName = (me: MeResponse) => `${me.firstName ?? me.givenName} ${me.lastName}`;

export const selectIsFirstDebtTransfer = (me: MeResponse) =>
  !('debtConsolidation' in me.activatedProducts && me.activatedProducts.debtConsolidation);

//TODO: FCSE-6303 - Take into account loan product debt
export const selectRemainingDebt = (me: MeResponse) => {
  const creditDebt = me.activatedProducts.credit?.amountUsed ?? 0;
  const debtConsolidationDebt =
    'debtConsolidation' in me.activatedProducts
      ? (me.activatedProducts.debtConsolidation?.amountUsed ?? 0)
      : 0;
  return creditDebt + debtConsolidationDebt;
};

export const selectActivatedProduct =
  (productName: ProductName) =>
  (me: MeResponse): DebtConsolidationProduct | CreditProduct | undefined => {
    if (productName === ProductName.CREDIT) {
      return me.activatedProducts.credit;
    }
    if (productName === ProductName.DEBT_CONSOLIDATION && 'debtConsolidation' in me.activatedProducts) {
      return me.activatedProducts.debtConsolidation;
    }
    return undefined;
  };

export const createAnnualInterestSelector = (productName: ProductName) => (me: MeResponse) => {
  const activatedProduct = selectActivatedProduct(productName)(me);
  return activatedProduct ? activatedProduct.annualInterest : 0;
};
